import { Quote, Star, ExternalLink, PenLine } from 'lucide-react';
import { clientReviews } from '../../mock';
import { useLang } from '../../i18n/LanguageContext';
import { SectionHeading } from './SectionHeading';
import { GOOGLE_REVIEWS_URL } from './constants';

export const Reviews = () => {
  const { t } = useLang();
  return (
    <section id="reviews" className="py-14 lg:py-20 bg-surface border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionHeading label={t.reviewsSection.label} title={t.reviewsSection.title} />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {clientReviews.map((r) => (
            <div key={r.id} className="bg-ink border border-white/10 p-6" data-testid={`review-${r.id}`}>
              <Quote size={22} className="text-gold/40 mb-3" />
              <div className="flex gap-1 mb-3">
                {[...Array(r.rating)].map((_, i) => (
                  <Star key={`star-${r.id}-${i}`} size={15} fill="#c7a154" color="#c7a154" />
                ))}
              </div>
              <p className="text-sm text-white/70 leading-relaxed mb-4">{r.review}</p>
              <span className="text-xs font-semibold text-white">{r.name}</span>
            </div>
          ))}
        </div>
        <div className="flex flex-col sm:flex-row justify-center gap-4 mt-10">
          <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 bg-gold hover:bg-gold-dark text-ink font-bold uppercase tracking-widest px-7 py-3.5 transition-colors text-sm" data-testid="read-google-reviews-button">
            <ExternalLink size={16} /> {t.reviewsSection.readGoogle}
          </a>
          <a href={GOOGLE_REVIEWS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 border border-gold text-gold hover:bg-gold/10 font-bold uppercase tracking-widest px-7 py-3.5 transition-colors text-sm" data-testid="leave-review-button">
            <PenLine size={16} /> {t.reviewsSection.leaveReview}
          </a>
        </div>
      </div>
    </section>
  );
};
